import { Button } from '@mui/material';

import styles from './ApplicationModal.module.css';

interface FormikModalHeaderSkeletonProps {
	title?: string;
	/** Handler for closing the modal */
	onClose: () => void;
}

export default function FormikModalHeaderSkeleton(props: FormikModalHeaderSkeletonProps) {
	return (
		<div
			id={'draggable-window'}
			className={styles.header}
		>
			{props.title}
			<div className={styles['actions']}>
				<Button
					variant='contained'
					disabled
				>
					Save
				</Button>
				<Button
					variant='outlined'
					sx={{ marginRight: '4px' }}
					onClick={() => {
						props.onClose();
					}}
				>
					Close
				</Button>
			</div>
		</div>
	);
}
